export default "__VITE_ASSET__BBeGWkgf__"